/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

export * from './sections'

export const EVENT_NAMES = {
  CALL: 'Call',
  CLICK: 'Click',
  CLICK_AMENITIES_EXPAND: 'Click Amenities Expand',
  CLICK_AUTOCOMPLETE_RESULT: 'Click Autocomplete Result',
  CLICK_CITY_GUIDE: 'Click City Guide',
  CLICK_COVID_RELIEF: 'Click Covid Relief',
  CLICK_FILTER_BAR: 'Click Filter Bar',
  CLICK_MESSAGE: 'Click Message',
  CLICK_SIMILAR_LISTING: 'Click Similar Listing',
  CLICK_TOUR_AVAILABILITY: 'Click Tour Availability',
  CLICK_VIEW_TIPS: 'Click View Tips',
  COMPLETE_SEARCH: 'Complete Search',
  COMPLETE_ONBOARDING: 'Complete Onboarding',
  CREATE_ACCOUNT: 'Create Account',
  CREATE_ALERT: 'Create Alert',
  DETAIL_PAGE_TOP_SIMILAR_LISTINGS: 'Detail Page Top Similar Listings',
  DISPLAY_DETAIL_VIRTUAL_TOUR_PROMPT: 'Display Detail Virtual Tour Prompt',
  DRAW: 'Draw',
  EMAIL_CAPTURE: 'Email Capture',
  ENCOUNTER_MEDIA: 'Encounter Media',
  FAVORITE: 'Favorite',
  LIST_ITEM_CARD_INFO: 'List Item Card Info',
  NUDGE_CLICK: 'Nudge Click',
  PLAY_MEDIA: 'Play Media',
  SEARCH_AMENITIES: 'Search Amenities',
  SEARCH_BAR_CLICK: 'Search Bar Click',
  SEARCH_RENT_RESEARCH: 'Search Rent Research',
  SEND_MESSAGE: 'Send Message',
  SEND_WAITLIST_MESSAGE: 'Send Waitlist Message',
  SET_FILTERS: 'Set Filters',
  SET_MOVE_IN_RANGE: 'Set Move-in Range',
  SHARE: 'Share',
  SIGN_IN: 'Sign In',
  SIGN_OUT: 'Sign Out',
  REPORT_PROPERTY: 'Report Property',
  UNDO_MESSAGE: 'Undo Message',
  UNDO_TOUR: 'Undo Tour',
  VIEW_CITY_GUIDE: 'View City Guide',
  VIEW_MESSAGE_MODAL: 'View Message Modal',
  VIEW_MODAL: 'View Modal',
  VIEW_MULTI_MSG_MODAL: 'View MultiMessage Modal',
  VIEW_SECTION: 'View Section',
  VIEW_PAGE: 'View Page',
  WEBSITE_CLICK: 'Website Click',

  // apply
  LISTING_APPLY: 'Listing - Apply',
  FLOORPLAN_APPLY: 'Floorplan - Apply',

  // local logic events
  CALCULATE_COMMUTE: 'Calculate Commute',
  CLICK_COMMUTE_MODE: 'Click Commute Mode',
  CLICK_SCORE: 'Click Score',
  CLICK_POI: 'Click POI',
  VIEW_POI: 'View POI',
  VIEW_TRANSPORTATION: 'View Transportation',
  CLICK_SHOW_MORE: '[Scores Widget] Click Show All Scores',
  VIEW_WIDGET: '[POI Widget] View',
  CLICK_POI_TAB: '[POI Widget] CLick Tab',
  CLICK_POI_PIN: '[POI Widget] Click Pin',

  // School data widget
  VIEW_SCHOOL_WIDGET: '[School Widget] View',
  CLICK_SCHOOL_WIDGET_TAB: '[School Widget] Click Tab',

  // Hood compare widget
  CLICK_BED_DROPDOWN: '[Hood Compare Widget] Click Bed Dropdown',
  CLICK_HOOD_1_DROPDOWN: '[Hood Compare Widget] Click Hood 1 Dropdown',
  CLICK_HOOD_2_DROPDOWN: '[Hood Compare Widget] Click Hood 2 Dropdown',

  // zstories
  DISPLAY_ZSTORIES: 'Display Stories',
  TAP_ZSTORY: 'Tap Story Item',
  HIDE_ZSTORY: 'Hide Stories',
  COMPLETE_ZSTORY: 'Complete Story',
  ZSTORY_VIEW_DETAIL: 'View Story Item Detail',
  ZSTORY_REQUEST_INFO: 'Request Info from Story',
  ZSTORY_FAVORITE: 'Story Add Favorite',
  ZSTORY_UNFAVORITE: 'Story Remove Favorite',
  ZSTORY_CALL: 'Story Call',

  // rent specials
  CLICK_RENT_SPECIAL_EXPAND: 'Click Rent Special Expand',

  // MF rent report
  VIEW_RENT_REPORT: 'View Rent Report',

  // MF analytics dash
  VIEW_MF_ANALYTICS: '[MF Analytics] Open report',
  VIEW_MF_ANALYTICS_SECTION: '[MF Analytics] View report section',

  // MF Portal
  VIEW_PAGE_PORTAL: '[Portal] View Page',
  CLICK_PORTAL: '[Portal] Click',

  // Direct Listings Manage
  DIRECT_LISTINGS_ACCOUNT_CREATION_SIGNUP:
    'Direct Listings - Account Creation - Sign Up',
  DIRECT_LISTINGS_PACKAGE_MODAL: 'Direct Listings - Package Modal',
  DIRECT_LISTINGS_LISTING_SOURCE: 'Direct Listings - Listing Source',

  // Messaging 3.0
  ACCEPT_MESSAGE: 'Accept Message',
  ARCHIVE_MESSAGE: 'Archive Message',
  CLICK_VIEW_NUMBER: 'Click view number',
  CLICK_CONVERSATION_SORT: 'Click Conversation Sort',
  DECLINE_MESSAGE: 'Decline Message',
  HTML_MESSAGE_CLICK: 'HTML Message Click',
  HTML_MESSAGE_OPEN: 'HTML Message Open',
  IAM_TOUR_AVAILABILITY: 'IAM Tour Availability',
  HTML_VIEW_MESSAGE_RESPONSE: 'HTML View Message Response',
  LANDLORD_CALL: 'Landlord Call',
  LANDLORD_PHONE_NUMBER_CLICK: 'Landlord Phone Number Click',
  RENTER_CALL: 'Renter Call',
  RENTER_PHONE_NUMBER_CLICK: 'Renter Phone Number Click',
  REQUEST_PROFILE_INFO: 'Request Profile Info',
  REQUEST_RENTAL_APPLICATION: 'Request Rental Application',
  REQUEST_SCREENING_DOCUMENTS: 'Request Screening Documents',
  SEND_RESPONSE: 'Send Response',
  SET_CONVERSATION_SORT: 'Set Conversation Sort',
  UNARCHIVE_MESSAGE: 'Unarchive Message',
  VIEW_CONVERSATION_LIST: 'View Conversation List',
  VIEW_CHAT_SCREEN: 'View Chat Screen',
  VIEW_PROPERTY_DETAILS: 'View Property Details',
  VIEW_RENTER_DETAILS: 'View Renter Details',
  VIEW_UNREAD_CONVERSATION: 'View Unread Conversation',

  // Prequal Start
  PREQUAL_SET_ANSWER: '[PreQual] Set Answer',
  PREQUAL_START: '[PreQual] Start',

  // MultiMessage
  MM_CLICK_DONT_SHOW_AGAIN: `[MM] Click "Don't show this again"`,
  MM_CLICK_EXIT: '[MM] Click Exit',
  MM_CLICK_DETAIL_PAGE: '[MM] Click Detail Page',
  MM_DESELECT: '[MM] De-select',
  PREPARE_MULTI_MESSAGE_MODAL: '[MM] Prepare MultiMessage Modal',

  // Zoom Map
  ZOOM_MAP: 'Zoom Map',

  // mint mobile
  MINT_MOBILE_BANNER_CLOSE: 'Mint Mobile Banner Close',
  MINT_MOBILE_BANNER_CLICK: 'Mint Mobile Banner Click',

  // Navbar events
  CLICK_NAVIGATION_LINK: '[Navbar] Click Navigation Link',
  OPEN_LEASE_LENGTH_MENU: '[Navbar] Open Lease Length Menu',
  SWITCH_LEASE_LENGTH: '[Navbar] Switch Lease Length',

  // Short term detail events
  DETAIL_DATE_CHANGE: 'Detail Date Change',
  EXTERNAL_LISTING_CLICKOUT: 'External Listing Clickout',

  // Tour booking events
  REQUEST_TOUR: 'Request Tour',

  // For You Web
  FOR_YOU_PREFERENCES_UPDATED: 'For You Preferences Updated',
  FOR_YOU_SEARCH_INTERACTION: 'Manual search interaction',
  FOR_YOU_POPULAR_INTERACTION: 'Popular section interaction',

  // Map list POI
  MAP_LIST_POI_APPLY_BUTTON_CLICK: 'Map List POI Apply Button Click',
  MAP_LIST_POI_CATEGORY_BUTTON_CLICK: 'Map List POI Category Button Click',
  MAP_LIST_POI_CLEAR_BUTTON_CLICK: 'Map List POI Clear Button Click',
  MAP_LIST_POI_NEARBY_BUTTON_CLICK: 'Map List POI Nearby Button Click',
  MAP_LIST_POI_MAP_MARKER_PIN_CLICK: 'Map List POI Map Marker Pin Click',
  MAP_LIST_POI_MAP_MARKER_POPOVER_CLOSE_CLICK:
    'Map List POI Map Marker Popover Close Click',
  MAP_LIST_POI_RESULTS: 'Map List POI Results',

  // Zoe
  ZOE_CHAT_INITIALIZED: 'Zoe Chat Initialized',
  ZOE_CHAT_LOGIN: 'Zoe Chat Login',
  ZOE_TOGGLE_CLICK: 'Zoe Toggle Click',
  ZOE_DEFAULT_QUESTION_SUGGESTION_CLICK:
    'Zoe Default Question Suggestion Click',
  ZOE_FOLLOW_UP_QUESTION_SUGGESTION_CLICK:
    'Zoe Follow Up Question Suggestion Click',
  ZOE_QUESTION_ENTERED: 'Zoe Question Entered',
  ZOE_QUESTION_SEND: 'Zoe Question Send',
  ZOE_NO_RESULT: 'Zoe No Result',
  ZOE_ENTRY_FILTER_BAR_CLICK: 'Zoe Entry Filter Bar Click',
  ZOE_ENTRY_SEARCH_BAR_CLICK: 'Zoe Entry Search Bar Click',
  ZOE_SEARCH_QUERY_SEND: 'Zoe Search Query Send',
  ZOE_SAVED_QUESTION_SUGGESTION_CLICK: 'Zoe Saved Question Suggestion Click',

  // LLM descriptions
  LLM_DESCRIPTION_FEEDBACK_POSITIVE: 'LLM Description Feedback Positive',
  LLM_DESCRIPTION_FEEDBACK_NEGATIVE: 'LLM Description Feedback Negative',

  // Temp events for debugging full width map list experiment
  GET_FULL_WIDTH_TOGGLE_VALUE_CALLED: 'Get Full Width Toggle Value Called',
  ACTIVATE_FULL_WIDTH_MAP_CALLED: 'Activate Full Width Map Called',
  FULL_WIDTH_MAP_ACTIVATED: 'Full Width Map Activated',

  // Detail Reels
  DETAIL_REELS_FEEDBACK_POSITIVE: 'Detail Reels Feedback Positive',
  DETAIL_REELS_FEEDBACK_NEGATIVE: 'Detail Reels Feedback Negative',

  // Tracking autocomplete <> geos mismatches
  AUTOCOMPLETE_GEOS_MISMATCH: 'Autocomplete Geos Mismatch',
} as const

export const PROP_NAMES = {
  BUTTON_CLICKED: 'Button Clicked',
  BUTTON_CLICKED_ON_DETAIL: 'Button Clicked on Detail',
  BUILDING_IDS: 'Building IDs',
  CITY_STATE_LOCATION: 'City State Location',
  COMPARISON_COUNT: 'Comparison Count',
  COMPARISON_TYPE: 'Comparison Type',
  COUNT: 'Count',
  CURRENT_TAB: 'Current Tab',
  DETAIL_NAVIGATION_TAB: 'Detail Navigation tab',
  DETAIL_PAGE_TYPE: 'Detail Page Type',
  DEVICE: 'Device',
  EDITED_FORM: 'Edited Form',
  EMAIL_NOTIFICATIONS: 'Email Notifications Enabled',
  FILTERS_COUNT: 'Filters Count',
  FORMATTED_ORIGIN: 'Formatted Origin',
  HOST: 'host',
  LINK_CLICKED: 'Link Clicked',
  LISTABLE_COUNT: 'Listable Count',
  LISTING_IDS: 'Listing IDs',
  MAP_LIST_SWITCH: 'Map List Switch',
  MEDIA_TYPE: 'Media Type',
  MODAL_NAME: 'Modal Name',
  ORIGIN: 'Origin',
  PAGE_INDEX: 'Page index',
  PAGE_NAME: 'Page Name',
  PREVIOUS_PAGE: 'Previous Page',
  PROPERTY_FEATURE: 'Property Feature',
  REPORT_TYPE: 'Report Type',
  SEARCH_RESULT_INDEX: 'Search Result Index',
  SEARCH_RESULT_PAGE: 'Search Result Page',
  SECTION: 'Section',
  SELECTED_TOUR_TYPE: 'Selected Tour Type',
  SHARE_ORIGIN: 'Share Origin',
  SIMILAR_LISTING_SECTION: 'Similar Listing Section',
  TOUR_PREFERENCE_COUNT: 'Tour Preference Count',
  TOUR_PREFERENCE_TYPE: 'Tour Preference Type',
  USER: 'User',
  ACTION: 'Action',
  USER_EMAIL: 'User Email',
  ZUMPER_SITE: 'Zumper Site',

  // filter props
  AMENITIES_FILTER: 'Amenities Filter',
  AMENITY_SEARCH_WORD: 'Amenity Search Word',
  BATHROOM_FILTER: 'Bathroom Filter',
  BEDROOM_FILTER: 'Bedroom Filter',
  BUILDING_FILTER: 'Building Filter',
  LEASE_LENGTH_FILTER: 'Lease Length Filter',
  MAX_PRICE_FILTER: 'Max Price Filter',
  MIN_PRICE_FILTER: 'Min Price Filter',
  NEIGHBORHOOD_FILTER: 'Neighborhood Filter',
  OTHER_FILTER: 'Other Filter',
  PETS_FILTER: 'Pets Filter',
  PROPERTY_FEATURE_FILTER: 'Property Feature Filter',
  TYPE_FILTER: 'Type Filter',
  RATING_FILTER: 'Rating Filter',

  // local logic props
  COMMUTE_MODE: 'Commute Mode',
  POI_LAT: 'POI Lat',
  POI_LNG: 'POI Lng',
  POI_NAME: 'POI Name',
  POI_TYPE: 'POI Type',

  // listing props
  BUILDING_AMENITIES: 'Building Amenities',
  BUILDING_ID: 'Building ID',
  BUILDING_PETS: 'Building Pet Policy',
  DEAL_ID: 'Deal ID',
  DESCRIPTION_LENGTH: 'Description Length',
  FEED_NAME: 'Feed Name',
  LISTING_AMENITIES: 'Listing Amenities',
  LISTING_AVAIL_DATE: 'Listing Availability Date',
  LISTING_BATHS: 'Listing Bath',
  LISTING_BEDS: 'Listing Bedrooms',
  LISTING_ID: 'Listing ID',
  LISTING_PETS: 'Listing Pet Policy',
  LISTING_PRICE: 'Listing Price',
  NUM_IMAGES: 'Number of Images',
  PROMO_TYPE: 'Promotion Type',
  PROPERTY_STATUS: 'Property Status',
  SQUARE_FOOTAGE: 'Square Footage',
  SPECIALS: 'Specials JSON',

  // onboarding props
  RANGE: 'Range',

  // renter nudge
  NUDGE_LIST_COUNT: 'Nudge List Count',
  NUDGE_LIST_POSITION: 'Nudge List Position',
  NUDGE_PROPERTY_ID: 'Property ID',

  // zstories
  ZSTORY_SLIDE_NUMBER: 'Story Slide Number',

  // MF rent report:
  SELECTED_MONTH: 'Selected Month',
  MF_ANALYTICS_SECTION: '[MF Analytics] Section',

  // MF Portal
  PORTAL_PAGE: '[Portal] Page',
  PORTAL_BUTTON: '[Portal] Button',
  CUSTOMER_TYPE: 'Customer Type',

  // Direct Listings Manage
  REAL_ESTATE_LICENSE_NUMBER: 'Real Estate License Number',
  COMPANY_NAME: 'Company Name',
  PACKAGE_TYPE: 'Package Type',
  LISTING_SOURCE: 'Listing Source',

  SIGN_UP_COMPLETE_PROFILE: '[Sign up] Complete profile',
  SIGN_UP_CREATE_PROFILE: '[Sign up] Create profile',
  SIGN_UP_ENTER_PHONE: '[Sign up] Enter phone number',
  SIGN_UP_ENTER_PHONE_VERIFICATION: '[Sign up] Enter phone verification code',
  SIGN_UP_CREATE_PASSWORD: '[Sign up] Create password',
  SIGN_UP_ENTER_PASSWORD: '[Sign up] Enter password',
  SIGN_UP_ERROR_SCREEN: '[Sign up] Error Screen',

  // sign up buttons
  SIGN_UP_AGREE_AND_CONTINUE: '[Sign up] Agree & continue',
  SIGN_UP_SKIP_PHONE_VERIFICATION: '[Sign up] Skip this for now',
  SIGN_UP_ALREADY_HAVE_AN_ACCOUNT: '[Sign up] Already have a account, Log in',
  SIGN_UP_RESEND_CODE: '[Sign up - Phone verification] Resend code',
  SIGN_UP_CALL_ME_INSTEAD: '[Sign up - Phone verification] Call me instead',
  SIGN_UP_TEXT_ME_INSTEAD: '[Sign up - Phone verification] Text me instead',
  SIGN_UP_VERIFICATION_CONTINUE: '[Sign up - Phone verification] Continue',
  SIGN_UP_FINISH: '[Sign up] Finish',
  LOGIN: 'Login',

  // Messaging 3.0
  CHANNEL_ID: 'Channel ID',
  DECLINE_REASON: 'Decline Reason',
  HAS_ATTACHMENT: 'hasAttachment',
  IS_MESSAGING_3: 'isMessaging3.0',
  STREAM_USER_ID: 'Stream User ID',
  CONVERSATION_SORT: 'Conversation Sort',

  // Prequal
  IS_PREQUAL_EXPIRED: 'isPreQualExpired',
  PREQUAL_ORIGIN: '[PreQual] Origin',
  PREQUAL_QUESTION_TYPE: '[PreQual] Question Type',

  // MultiMessage
  MM_INDEX: '[MM] Index',

  // Category Listables
  FURNISHED_LISTING_COUNT: 'Furnished Listing Count',
  FILTER_SECTION: 'Filter Section',
  FILTER_SECTION_ACTION: 'Filter Section Action',
  IN_UNIT_LAUNDRY_COUNT: 'In Unit Laundry Listing Count',
  LUXURY_LISTING_COUNT: 'Luxury Listing Count',
  MOVE_IN_SPECIAL_LISTING_COUNT: 'Move In Special Listing Count',
  PET_FRIENDLY_LISTING_COUNT: 'Pet Friendly Listing Count',
  SECTION_TARGET: 'Section Target',
  SHORT_TERM_LISTING_COUNT: 'Short Term Listing Count',
  UTILITIES_INCLUDED_LISTING_COUNT: 'Utilities Included Listing Count',

  // Zoom Map
  ZOOM_LEVEL: 'Zoom Level',

  // Mint Mobile
  MINT_MOBILE_BANNER_IMPRESSION: 'Mint Mobile Banner Impression',

  // Navbar events
  NAVBAR_LINK_TYPE: '[Navbar] Link Type',

  // Short-term rentals
  ADULTS: 'Adults',
  CHILDREN: 'Children',
  GUESTS: 'Guests',
  REASON: 'Reason',
  LISTING_TYPE: 'Listing Type',
  LISTING_FEED_NAME: 'Listing Feed Name',
  LEASE_LENGTH: 'Lease Length',
  LEASE_LENGTH_TYPE: 'Lease Length Type',
  LEASE_TYPE: 'Lease Type',
  MIN_LEASE_DAYS: 'Min Lease Days',
  MAX_LEASE_DAYS: 'Max Lease Days',
  SHORT_TERM_START_DATE: 'Short-Term Start Date',
  SHORT_TERM_END_DATE: 'Short-Term End Date',

  // Tour Booking props
  TOUR_BUTTON_TYPE: 'Tour Button Type',

  // Filter ads
  IS_FILTER_AD: 'Is Filter Ad',
  MAPLIST_CARD_INDEX: 'Maplist Card Index',

  // For You Web
  FOR_YOU_QUESTION_INDEX: 'For You Question Index',
  FOR_YOU_QUESTION_INDEX_NAME: 'For You Question Index Name',
  PREVIOUS_QUESTION_ACTION_TYPE: 'Previous Question Action Type',
  PREFERENCES_EDITED: 'Preferences Edited',
  PREFERENCES_SECTION: 'Preferences Section',
  FOR_YOU_LISTING_ACTIONS: 'Listing actions interested in',
  // Neighborhoods and Amenities
  FOR_YOU_IS_MANUAL_SEARCH: 'Is Manual Search',
  FOR_YOU_IS_POPULAR: 'Is Popular',
  FOR_YOU_SELECTED_ITEMS: 'Selected Items',

  // STR Interest
  STR_INTEREST_TYPE: 'Type',
  STR_INTEREST_INFORMATION_SUBMITTED: 'Information Submitted',

  // Autocomplete
  CITY_STATE: 'City State',
  RESULT_INDEX: 'Result Index',
  RESULT_TYPE: 'Result Type',
  SELECTED_RESULT: 'Selected Result',

  BEDROOM_COUNT: 'Bedroom Count',
  CITY_SELECTED: 'City Selected',
  CITY_ORIGIN: 'City Origin',
  PROPERTY_TYPE: 'Property Type',

  // DETAIL ACTIVE/INACTIVE LISTINGS
  ACTIVE_LISTINGS: 'Active Listings',
  INACTIVE_LISTINGS: 'Inactive Listings',

  // Multi-message
  MM_LISTING_IDS: 'MM Listing IDs',
  RATE_LIMITED: 'Rate limited',
  IS_RENTPATH: 'Is Rentpath',
  IS_MM_PREVENT: 'Is MM Prevent',
  DISPLAYING: 'Displaying',
  SHOW_PRE_LEAD_SIGN_IN: 'Show pre-lead sign in',

  // AI assistant
  QUESTION_ASKED: 'Question Asked',

  // LLM descriptions
  PA_URL: 'Permanent Address Url',

  // Temp prop names for de
  VARIATION: 'variation',
  TOGGLE_VALUE: 'toggleValue',
  IS_CURRENT_SEARCH_VIEW: 'isCurrentSearchView',
  DEFAULT_TOGGLE_VALUE: 'defaultToggleValue',
  IS_ZUMPER_RENTALS: 'IS_ZUMPER_RENTALS',

  // Props for autocomplete <> geos mismatch
  AUTOCOMPLETE_URL: 'Autocomplete URL',
  AUTOCOMPLETE_CITY_NAME: 'Autocomplete City Name',
  AUTOCOMPLETE_HOOD_NAME: 'Autocomplete Hood Name',
  AUTOCOMPLETE_BOX: 'Autocomplete Box',
  AUTOCOMPLETE_LAT: 'Autocomplete Lat',
  AUTOCOMPLETE_LNG: 'Autocomplete Lng',
  AUTOCOMPLETE_TYPE: 'Autocomplete Type',
  AUTOCOMPLETE_NAME: 'Autocomplete Name',
  GEOS_URL: 'Geos URL',
  GEOS_CITY_NAME: 'Geos City Name',
  GEOS_HOOD_NAME: 'Geos Hood Name',
  GEOS_BOX: 'Geos Box',
  GEOS_LAT: 'Geos Lat',
  GEOS_LNG: 'Geos Lng',
} as const

export enum RENT_RESEARCH_BUTTON_CLICKS {
  // DETAIL
  DETAIL_NEARBY_LOCATIONS_AVERAGE_RENT = 'Rent Research Detail Nearby Locations Average Rent',
  DETAIL_COMPARABLES_TAB_PROPERTY_TYPE = 'Rent Research Detail Comparables Tab Property Type',
  DETAIL_COMPARABLES_TAB_NEIGHBORHOODS = 'Rent Research Detail Comparables Tab Neighborhoods',
  DETAIL_COMPARABLES_TAB_NEARBY = 'Rent Research Detail Comparables Tab Nearby',
  DETAIL_COMPARABLES_TAB_BEDROOMS = 'Rent Research Detail Comparables Tab Bedrooms',
  DETAIL_COMPARABLES_VIEW_COMPARABLES = 'Rent Research Detail Comparables View Comparables',
  DETAIL_COMPARE_RENT_LOCATION_DROPDOWN = 'Rent Research Detail Compare Rent Location Dropdown',
  DETAIL_DISCOVER_LISTINGS_TAB_AFFORDABLE = 'Rent Research Detail Discover Listings Tab Affordable',
  DETAIL_DISCOVER_LISTINGS_TAB_LUXURY = 'Rent Research Detail Discover Listings Tab Luxury',
  DETAIL_DISCOVER_LISTINGS_TAB_PET_FRIENDLY = 'Rent Research Detail Discover Listings Tab Pet Friendly',
  DETAIL_DISCOVER_LISTINGS_TAB_HIGHEST_RATED = 'Rent Research Detail Discover Listings Tab Highest Rated',
  DETAIL_DISCOVER_LISTINGS_TAB_DEALS = 'Rent Research Detail Discover Listings Tab Deals',
  DETAIL_DISCOVER_LISTINGS_VIEW_ALL = 'Rent Research Detail Discover Listings View All',
  DETAIL_DISCOVER_LISTINGS_LISTING = 'Rent Research Detail Discover Listings Listing',
  DETAIL_DATA_INSIGHTS_REPORT = 'Rent Research Detail Data Insights Report',

  // HOMEPAGE
  HOME_DATA_INSIGHTS_REPORT = 'Rent Research Home Data Insights Report',
  HOME_TOP_CITIES_BED_DROPDOWN = 'Rent Research Home Top Cities Bed Dropdown',
  HOME_TOP_CITIES_PROPERTY_TYPE_DROPDOWN = 'Rent Research Home Top Cities Property Type Dropdown',
  HOME_TOP_CITIES_CITY = 'Rent Research Home Top Cities City',
  HOME_TOP_NEIGHBORHOODS_NEIGHBORHOOD = 'Rent Research Home Top Neighborhoods Neighborhood',
  HOME_TOP_NEIGHBORHOODS_BED_DROPDOWN = 'Rent Research Home Top Neighborhoods Bed Dropdown',
  HOME_TOP_NEIGHBORHOODS_PROPERTY_TYPE_DROPDOWN = 'Rent Research Home Top Neighborhoods Property Type Dropdown',
}

export enum RENT_RESEARCH_SECTIONS {
  // DETAIL
  DETAIL_AVERAGE_RENT_COMPARABLE_TABLE = 'Rent Research Detail Average Rent Comparable Table',
  DETAIL_NEARBY_LOCATIONS_AVERAGE_RENT = 'Rent Research Detail Nearby Locations Average Rent',
  DETAIL_DISCOVER_LISTINGS = 'Rent Research Detail Discover Listings',
  DETAIL_COMPARE_RENT = 'Rent Research Detail Compare Rent',
  DETAIL_COST_OF_LIVING = 'Rent Research Detail Cost of Living',
  DETAIL_DATA_INSIGHTS = 'Rent Research Detail Data Insights',
  DETAIL_RENT_PRICE_SUMMARY = 'Rent Research Detail Rent Price Summary',

  // HOME
  HOME_DATA_INSIGHTS = 'Rent Research Home Data Insights',
  HOME_TOP_CITIES = 'Rent Research Home Top Cities',
  HOME_TOP_NEIGHBORHOODS = 'Rent Research Home Top Neighborhoods',
}

export enum RESIDENT_QUOTES_SECTIONS {
  RAIL = 'Resident Quotes Rail',
  MAIN = 'Resident Quotes Main Section',
}

export enum RESIDENT_QUOTES_BUTTON_CLICKS {
  VIEW_ALL = 'Resident Quotes View All',
  CHAT = 'Resident Quotes Chat - Open Modal',
  START_CHAT = 'Resident Quotes Start Chat',
}

export enum BUILDING_REVIEWS_SECTIONS {
  MAIN = 'Building Reviews Main',
}

export enum BUILDING_REVIEWS_BUTTON_CLICKS {
  OPEN_REVIEW = 'Building Reviews - Open Modal',
}

export enum BUTTON_CLICKED_ON_DETAIL_TYPES {
  AMENITIES_VIEW_ALL = 'Amenities - View All',
  AVAILABLE_NEARBY_MESSAGE_ALL_PROPERTIES = 'Available Nearby - Message all Properties',
  BACK = 'Back',
  COMPARE_SIMILAR_MESSAGE_ALL = 'Compare similar - Message all',
  COMPARE_SIMILAR_CLICK_ONE = 'Compare similar - Click one',
  FLOORPLAN_SUMMARY = 'Floorplan Summary',
  HASHTAG = 'Hashtag',
  MAP_GET_DIRECTIONS = 'Map - Get Directions',
  RENT_SPECIAL_READ_MORE = 'Rent Special - Read More',
  ZOE_ENTRY_BOTTOM = 'Zoe Entry Bottom',
  ZOE_ENTRY_TOP = 'Zoe Entry Top',
}

export const PAGE_NAMES = {
  BOOKING_MODULE: 'Booking Module',
  BUBBLE: 'Bubble',
  CATEGORY_LANDING: 'Category Landing',
  CHAT_SCREEN: 'Chat Screen',
  DETAIL: 'Detail',
  EXPANDED_GLOBAL_SEARCH: 'Expanded Global Search',
  FAVORITES: 'Favorites',
  FOR_YOU_EMAIL_CAPTURE: 'For You Email Capture',
  FOR_YOU_LANDING: 'For You Landing',
  FOR_YOU_PREFERENCES: 'For You Preferences',
  FOR_YOU_QUESTION: 'For You Question',
  FOR_YOU_RESULTS: 'For You Results',
  FOR_YOU_CREATE_ACCOUNT: 'For You Create Account',
  FOR_YOU_DESTINATION: 'For You Destination',
  FOR_YOU_NEIGHBORHOODS: 'For You Neighborhoods',
  HOMEPAGE: 'Homepage',
  HOMEPAGE_ZUMPER_RENTALS: 'Homepage Zumper Rentals',
  MEDIA: 'Media',
  MESSAGED: 'Messaged',
  SAVED_SEARCHES: 'Saved Searches',
  SEARCH: 'Search',
  SEARCH_MAP: 'Search - Map',
  SEARCH_LIST: 'Search - List',
  RENTER_M3_SIGN_IN: 'Sign In - Messaging',
  RENTER_M3_SIGN_UP: 'Sign Up - Messaging',
  RENT_RESEARCH_HOME: 'Rent Research Home',
  RENT_RESEARCH_DETAIL: 'Rent Research Detail',
  ONBOARDING: 'Onboarding',
  PERM_ADDRESS: 'Permanent Address',
  PROGRAMMATIC_RENT: 'Programmatic Rent Report',
  RENTAL_TYPE: 'Rental type',
  STR_LANDING: 'STR Landing Page',
  VERTICAL_GALLERY: 'Vertical Gallery',
  FOCUS_STATE: 'Focus State',
  ZOE: 'Zoe',
} as const

export const FOR_YOU_ACTION_TYPES = {
  ANSWERED: 'Answered',
  SKIPPED: 'Skipped',
} as const

export enum DETAIL_PAGE_TYPES {
  LISTING = 'Listing',
  BUILDING = 'Building',
  OLD_LISTING = 'Old Listing',
  PERM_ADDRESS = 'Permanent Address',
  PERM_ADDRESS_SINGLE_UNIT = 'Permanent Address - Single',
  PERM_ADDRESS_SINGLE_ACTIVE_UNIT = 'Permanent Address - Single Active Unit',
}

export const PROPERTY_FEATURES = {
  DIRECT_DEAL: 'Direct Deal',
  FEATURED: 'Featured',
  INSTARENT: 'Instarent',
  PRO: 'Pro',
  THIRD_PARTY: 'Third Party',
  TOUR_ENABLED: 'Tour Enabled',
} as const

export const FILTER_PROPERTY_FEATURES = {
  RENT_SPECIAL: 'Rent Special',
  NO_SECURITY_DEPOSIT: 'No Security Deposit',
  PRICE_DROP: 'Price Drop',
  SWEET_DEAL: 'Sweet Deal',
  UTILITIES_INCLUDED: 'Utilities Included',
} as const

export const MEDIA_TYPES = {
  IMAGE: 'Image',
  THREE_D: '3D',
  VIDEO: 'Video',
  INTERNAL_VIDEO: 'Internal Video',
} as const

export const FILTER_BUTTON_NAMES = {
  AVAILABLE_NOW: 'Available Now',
  BATH: 'Bath',
  BED: 'Bed',
  DEALS: 'Deals',
  HIGHEST_RATED: 'Highest Rated',
  LEASE_LENGTH: 'Lease Length',
  PETS: 'Pets',
  PRICE: 'Price',
  PROPERTY_TYPE: 'Property Type',
  SEE_ALL_FILTERS: 'See All Filters',
} as const

export const SHARE_ORIGINS = {
  DETAIL: 'Detail',
  CAROUSEL: 'Carousel',
} as const

export const TOUR_PREFERENCE_TYPES = {
  AVAILABILITY: 'Availability',
  KNOCK: 'Knock',
  OPEN_HOUSE: 'Open House',
} as const

export const SIMILAR_LISTING_SECTION_TYPES = {
  TOP: 'Top',
  BOTTOM: 'Bottom',
} as const

export const ONBOARDING_PAGE_NAMES = {
  BED: 'Onboarding - Bedrooms',
  PRICE: 'Onboarding - Price',
  MOVE_IN_RANGE: 'Onboarding - Move-in Range',
  ALERT: 'Onboarding - Alert Creation',
  EMAIL: 'Onboarding - Email Capture',
  PROPERTY_TYPE: 'Onboarding - Property Type',
  BUDGET: 'Onboarding - Budget',
} as const

export const RENTER_NUDGE_PAGE_NAMES = {
  NUDGE_MODAL_INTRO: 'Nudge Modal Intro',
  NUDGE_MODAL_NEXT_STEP: 'Nudge Modal Next Step',
} as const

export const RENTER_NUDGE_CLICK_TYPES = {
  CALL: 'Call',
  EXIT: 'Exit',
  NO: 'No',
  NO_INTEREST: 'No Interest',
  NUDGE: 'Nudge Landlord',
  SKIP: 'Skip',
  YES: 'Yes',
} as const

export const CLICK_TYPES = {
  STR_INTERSTITIAL: 'STR Interstitial',
  CTA: 'CTA',
  LIST_CARD: 'List card',
} as const

export const WEBSITE_CLICK_TYPES = {
  FROM_ABOUT: 'From About',
  FROM_CONTACT: 'From Contact',
  FROM_PCM: 'From PCM',
} as const

export const TOUR_BUTTON_TYPES = {
  BOOK_A_TOUR: 'Book a Tour',
  REQUEST_A_TOUR: 'Request a Tour',
  INLINE_TOUR_DATES: 'Inline tour dates',
  SEE_ALL_DATES: 'See all dates',
} as const

export const LEASE_LENGTH_TYPES = {
  SHORT_TERM: 'Short Term',
  LONG_TERM: 'Long Term',
} as const

export const SECTIONS = {
  SET_LOCATION: 'Set location',
} as const

export const ST_ONBOARDING_PAGE_NAMES = {
  CALENDAR: 'Onboarding - Calendar',
  GUEST_PICKER: 'Onboarding - Guest Picker',
} as const

export const VERTICAL_GALLERY_CLICK_TYPES = {
  GALLERY_REEL: 'Gallery Reel',
  GALLERY_IMAGE: 'Gallery Image',
  GALLERY_VIDEO: 'Gallery Video',
  GALLERY_TOUR: 'Gallery Tour',
  TAB_IMAGE: 'Tab Image',
  TAB_VIDEO: 'Tab Video',
  TAB_TOUR: 'Tab Tour',
  TAB_REEL: 'Tab Reel',
} as const
